import { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton } from '@material-ui/core';
import useStylesCommon from '../common/AdditionalDetailsCommonStyles';
import i18nNamespaces from '../../../../const/i18nNamespaces';
import { useTranslation } from 'react-i18next';
import { GetApp } from '@material-ui/icons';
import filesDownloadProvider from '../../../../services/filesDownloadProvider';
import Loading from '../../../common/Loading/Loading';
import { ReferralResponseDto } from '../../../../types/referrals';
import { referralApi } from '../../../../api/referral/referralApi';
import { getReferralFileName } from '../../../../utils/referral';
import axios from 'axios';
import { AlertContext } from '../../../../contexts/AlertContext';

type PatientReferralsListProps = {
    referrals?: ReferralResponseDto[];
};

const useStyles = makeStyles((theme) => ({
	orderItem: {
        marginTop: 20,
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    orderDetails: {
        display: 'flex',
        flexDirection: 'column',

    }
}));

const PatientP1ReferralsList = ({ referrals }: PatientReferralsListProps) => {
    const classesCommon = useStylesCommon();
    const {t} = useTranslation(i18nNamespaces.REFERRAL);
    const {t: tCommon} = useTranslation(i18nNamespaces.COMMON);
    const {t: tErrors} = useTranslation(i18nNamespaces.ERRORS);
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const openAlert = useContext(AlertContext);

    const handleDownloadReferal = async (referralId: string) => {
        try {
            setLoading(true);
            const {data: url} = await referralApi.getReferralPdf(
                referralId,
            );
            filesDownloadProvider.downloadFileFromUrl(
                url,
                getReferralFileName(referrals.find(r => r.id === referralId)!, t),
            );
        } catch (error) {
            if (axios.isAxiosError(error) &&
                error.response?.status === 404)
                openAlert({
                    severity: 'error',
                    message: tCommon('fileNotGenerated'),
                });
            else
                openAlert({
                    severity: 'error',
                    message: tErrors('downloadReferralError'),
                });
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <Box style={{marginBottom: 20, marginTop: 20}}>
            <Loading loading={loading} withBackdrop />
            <h4 className={`${classesCommon.detailsHeader}`}>
                {t('referrals')}
            </h4>
            {referrals && referrals.length > 0 ? (
                referrals.map(referral => (
                    <Box key={referral.id} className={classes.orderItem}>
                        <Box className={classes.orderDetails}>
                            {t(referral.type)}, {referral.orgUnitSpecialty.name}, {t('code')}: {referral.code}
                        </Box>
                        <Box>
                            <IconButton
                                size={'small'}
                                style={{marginLeft: 10}}
                                onClick={() => handleDownloadReferal(referral.id)}
                            >
                                <GetApp fontSize={'small'} color={'secondary'}/>
                            </IconButton>
                        </Box>
                    </Box>
                ))
            ) : (
                <p>{t('noReferrals')}</p>
            )}
        </Box>
    );
};

export default PatientP1ReferralsList;
